export const RESET_PROMOCODES_ERROR = 'vzr/RESET_PROMOCODES_ERROR';

export const FETCH_PROMOCODES = 'vzr/FETCH_PROMOCODES';
export const FETCH_PROMOCODES_FAIL = 'vzr/FETCH_PROMOCODES_FAIL';
export const FETCH_PROMOCODES_SUCCESS = 'vzr/FETCH_PROMOCODES_SUCCESS';

export const FETCH_PROMOCODE = 'vzr/FETCH_PROMOCODE';
export const FETCH_PROMOCODE_FAIL = 'vzr/FETCH_PROMOCODE_FAIL';
export const FETCH_PROMOCODE_SUCCESS = 'vzr/FETCH_PROMOCODE_SUCCESS';

export const CREATE_PROMOCODE = 'vzr/CREATE_PROMOCODE';
export const CREATE_PROMOCODE_FAIL = 'vzr/CREATE_PROMOCODE_FAIL';
export const CREATE_PROMOCODE_SUCCESS = 'vzr/CREATE_PROMOCODE_SUCCESS';

export const UPDATE_PROMOCODE = 'vzr/UPDATE_PROMOCODE';
export const UPDATE_PROMOCODE_FAIL = 'vzr/UPDATE_PROMOCODE_FAIL';
export const UPDATE_PROMOCODE_SUCCESS = 'vzr/UPDATE_PROMOCODE_SUCCESS';

export const DELETE_PROMOCODE = 'vzr/DELETE_PROMOCODE';
export const DELETE_PROMOCODE_FAIL = 'vzr/DELETE_PROMOCODE_FAIL';
export const DELETE_PROMOCODE_SUCCESS = 'vzr/DELETE_PROMOCODE_SUCCESS';

export const FETCH_PROMOCODE_COMMISSIONS = 'vzr/FETCH_PROMOCODE_COMMISSIONS';
export const FETCH_PROMOCODE_COMMISSIONS_FAIL = 'vzr/FETCH_PROMOCODE_COMMISSIONS_FAIL';
export const FETCH_PROMOCODE_COMMISSIONS_SUCCESS = 'vzr/FETCH_PROMOCODE_COMMISSIONS_SUCCESS';

export const CREATE_PROMOCODE_COMMISSION = 'vzr/CREATE_PROMOCODE_COMMISSION';
export const CREATE_PROMOCODE_COMMISSION_FAIL = 'vzr/CREATE_PROMOCODE_COMMISSION_FAIL';
export const CREATE_PROMOCODE_COMMISSION_SUCCESS = 'vzr/CREATE_PROMOCODE_COMMISSION_SUCCESS';

export const UPDATE_PROMOCODE_COMMISSION = 'vzr/UPDATE_PROMOCODE_COMMISSION';
export const UPDATE_PROMOCODE_COMMISSION_FAIL = 'vzr/UPDATE_PROMOCODE_COMMISSION_FAIL';
export const UPDATE_PROMOCODE_COMMISSION_SUCCESS = 'vzr/UPDATE_PROMOCODE_COMMISSION_SUCCESS';

export const DELETE_PROMOCODE_COMMISSION = 'vzr/DELETE_PROMOCODE_COMMISSION';
export const DELETE_PROMOCODE_COMMISSION_FAIL = 'vzr/DELETE_PROMOCODE_COMMISSION_FAIL';
export const DELETE_PROMOCODE_COMMISSION_SUCCESS = 'vzr/DELETE_PROMOCODE_COMMISSION_SUCCESS';
